import { Fragment, type ReactElement } from "react"

import { useTranslation } from "react-i18next"

import { Grid } from "@mui/material"
import { Typography } from "@synapse-analytics/synapse-ui"

import type { SuggestionsMessageProps } from "../interfaces"

import styles from "./SummaryMessage.module.scss"

function SummaryMessage(props: Readonly<SuggestionsMessageProps>): ReactElement {
  const { t } = useTranslation("KonanAssistant")
  const { bulletPoint, actions } = props

  return (
    <Fragment>
      <Typography>
        {t("summaryMessage.introText")}
        <br />
        <br />
        <ul className={styles.summaryList}>
          {bulletPoint.map((point) => (
            <li key={point.point}>
              <strong>{point.component}:</strong> {point.point}
            </li>
          ))}
        </ul>
      </Typography>

      {actions && (
        <Fragment>
          <br />
          <Grid container display={"flex"} item xs={12} gap={1}>
            {actions?.map((action, index) => (
              <Fragment key={index}>{action}</Fragment>
            ))}
          </Grid>
        </Fragment>
      )}
    </Fragment>
  )
}

export { SummaryMessage }
